import type { ReactNode } from "react";

import { GlassCard } from "./GlassCard";

interface MetricCardProps {
  title: string;
  value: string;
  detail?: string;
  meta?: ReactNode;
}

export function MetricCard({ title, value, detail, meta }: MetricCardProps) {
  return (
    <GlassCard className="metric-card stack-sm">
      <span className="card-eyebrow">{title}</span>
      <div className="metric-value">{value}</div>
      {detail ? <p className="card-copy">{detail}</p> : null}
      {meta}
    </GlassCard>
  );
}
